import type { JWT } from '@aws-amplify/core';

/**
 * Supported user roles in the application.
 * Hierarchy: admin > user > read-only
 */
export type UserRole = 'admin' | 'user' | 'read-only';

export interface AuthUser {
  userId: string;
  username: string;
  email: string;
  role: UserRole;
}

const VALID_ROLES: ReadonlySet<string> = new Set<UserRole>([
  'admin',
  'user',
  'read-only',
]);

/**
 * Extracts the user role from a JWT token's `custom:role` claim.
 * Returns `read-only` for missing or invalid claims.
 */
export function extractRole(payload: JWT['payload']): UserRole {
  const claim = payload?.['custom:role'];

  if (typeof claim === 'string' && VALID_ROLES.has(claim)) {
    return claim as UserRole;
  }

  return 'read-only';
}
